<template lang="pug">
  .quotation-info
    TitleBar {{ $t('报价信息') }}

    div(style="margin-left: 20px")
      el-row
        el-col(:span="24")
          el-button(@click="show = true") {{ $t('查看明细') }}
      el-row
        el-col(:span="24")
          QuotationOverview(
            :data="tableData.price_overview"
            :shouldShowIncrement="tableData.increment_ratio !== 0"
          )

    quotation-dialog(
      v-if="quotationDetail.length !== 0"
      view-mode
      :visible="show"
      :data="dialogData"
      @close="show = false"
    )
</template>

<script>
import TitleBar from '@/components/TitleBar'
import QuotationOverview from '@/components/QuotationOverview'
import QuotationDialog, { normalizeQuotation } from '@/components/QuotationDialog'

export default {
  components: {
    TitleBar,
    QuotationDialog,
    QuotationOverview
  },
  props: {
    isBeyond: {
      type: Boolean,
      default: false
    },
    tableData: {
      type: Object,
      default () {
        return {

        }
      }
    },
    quotationDetail: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      show: false
    }
  },
  computed: {
    dialogData () {
      return this.quotationDetail.map(item => normalizeQuotation(item))
    }
  }
}
</script>
